<input #fileInput type="file" class="file-input" tabindex="-1" aria-hidden="true" (change)="onFilesChosen($event)" />
<section class="pm-media" *transloco="let tr; prefix: 'productDefinitions.media'; scope: 'product-definitions'">
  <div class="head">
    <h3 class="h3">{{ tr('title') }}</h3>
    <span class="lead">{{ tr('lead.before') }} <b>{{ tr('lead.main') }}</b> {{ tr('lead.after') }}</span>
  </div>

  @if (state.loading()) {
    <nz-skeleton [nzActive]="true"></nz-skeleton>
  } @else if (state.loadFailed()) {
    <div class="notice err" role="alert">
      <hc-media-icon name="info" [size]="16"></hc-media-icon>
      <span class="grow">{{ tr('loadFailed') }} {{ state.loadFailedText() }}</span>
      <button nz-button type="button" (click)="reload()">{{ tr('reload') }}</button>
    </div>
  } @else {
    @if (state.readOnly() === 'rights') {
      <div class="notice info" role="status"><hc-media-icon name="info" [size]="16"></hc-media-icon><span>{{ tr('readOnly.rights') }}</span></div>
    } @else if (state.readOnly() === 'disabled') {
      <div class="notice warn" role="status"><hc-media-icon name="info" [size]="16"></hc-media-icon><span>{{ tr('readOnly.disabled') }}</span></div>
    }

    <div class="bar">
      <div class="counters">
        <span class="counter">{{ tr('counter.photos', { n: state.counts().photos, max: state.limits().photos }) }}</span>
        <span class="counter">{{ tr('counter.videos', { n: state.counts().videos, max: state.limits().videos }) }}</span>
        @if (working()) {
          <span class="saving"><span class="dot" aria-hidden="true"></span>{{ tr('saving') }}</span>
        } @else {
          @if (state.savedNote(); as note) {
            <span class="saved"><hc-media-icon name="check" [size]="14" [width]="2.4"></hc-media-icon>{{ tr('saved.' + note) }}</span>
          }
        }
      </div>
      @if (state.editable()) {
        <button nz-button type="button" nz-dropdown nzTrigger="click" nzPlacement="bottomRight" [nzDropdownMenu]="copyMenu" [disabled]="copyDisabled()" (nzVisibleChange)="onCopyVisible($event)">
          {{ tr('copy.button') }}<hc-media-icon name="down" [size]="12"></hc-media-icon>
        </button>
        <nz-dropdown-menu #copyMenu="nzDropdownMenu">
          <div class="copy-pop">
            @if (state.siblingsLoading()) {
              <div class="copy-note"><span class="spin" aria-hidden="true"></span>{{ tr('copy.loading') }}</div>
            } @else if (state.siblingsFailed()) {
              <div class="copy-note bad">{{ tr('copy.failed') }}</div>
            } @else if (siblingRows().length === 0) {
              <div class="copy-note">{{ tr('copy.none') }}</div>
            } @else {
              <ul nz-menu>
                @for (s of siblingRows(); track s.id) {
                  <li nz-menu-item [nzDisabled]="s.ready === 0" (click)="onCopy(s)">
                    <span class="th">
                      @if (s.thumb) {
                        <img [src]="s.thumb.src" [attr.srcset]="s.thumb.srcset" alt="" />
                      }
                    </span>
                    <span class="two"><span>{{ s.title }}</span><span class="help">{{ s.sub }}</span></span>
                  </li>
                }
              </ul>
            }
            <div class="copy-foot">{{ tr('copy.hint') }}</div>
          </div>
        </nz-dropdown-menu>
      }
    </div>

    <div class="grid" role="list" [attr.aria-label]="tr('gridAria')">
      @if (state.legacyUrl(); as legacy) {
        <div class="tile old" role="listitem">
          <div class="ph">
            @if (!legacyBroken()) {
              <img class="legacy-pic" [src]="legacy" alt="" draggable="false" (error)="legacyBroken.set(true)" />
            } @else {
              <span class="legacy-empty"><hc-media-icon name="image" [size]="28" [width]="1.5"></hc-media-icon></span>
            }
            <span class="chip">375 × 402</span>
          </div>
          <span class="meta"><b>{{ tr('legacy.title') }}</b> · 375 × 402 — {{ tr('legacy.please') }}</span>
          <span class="warnline"><hc-media-icon name="info" [size]="12"></hc-media-icon>{{ tr('legacy.hint') }}</span>
          @if (state.editable()) {
            <div class="links"><button type="button" class="lnk" (click)="pick({ front: true })">{{ tr('legacy.replace') }}</button></div>
          }
        </div>
      }

      @for (row of rows(); track row.tile.key) {
        <hc-media-tile
          role="listitem"
          [attr.draggable]="row.draggable"
          [tile]="row.tile"
          [last]="row.last"
          [editable]="state.editable()"
          [busy]="row.busy"
          [orderBusy]="state.orderBusy()"
          [dropOver]="dragOver() === row.tile.index"
          [limits]="state.limits()"
          (dragstart)="onDragStart($event, row.tile.index)"
          (dragover)="onTileDragOver($event, row.tile.index)"
          (dragleave)="onTileDragLeave(row.tile.index)"
          (drop)="onTileDrop($event, row.tile.index)"
          (dragend)="endDrag()"
          (moveLeft)="onMove(row.tile, -1)"
          (moveRight)="onMove(row.tile, 1)"
          (makeMain)="onMakeMain(row.tile)"
          (frame)="onFrame(row.tile)"
          (replace)="onReplace(row.tile)"
          (remove)="onRemove(row.tile)"
          (retry)="onRetry(row.tile)"
          (retryUpload)="onRetryUpload(row.tile)"
          (cancelUpload)="onCancel(row.tile)"
          (retryReplacement)="onRetryReplacement(row.tile)"
          (cancelReplacement)="onCancelReplacement(row.tile)"
        ></hc-media-tile>
      }

      @if (state.editable() && freeKind(); as kind) {
        <div class="tile free-tile">
          <button type="button" class="free" (click)="pick()">
            <hc-media-icon name="plus" [size]="20"></hc-media-icon>
            <span>{{ tr('free.' + kind) }}</span>
            <span class="help">{{ tr('free.sub.' + kind, { photos: freePhotos() }) }}</span>
          </button>
        </div>
      }
    </div>

    <span class="help order-hint">{{ tr('orderHint.before') }} <b>⠿</b> {{ tr('orderHint.after') }}</span>

    @for (toast of state.toasts(); track toast.id) {
      <div class="toasts">
        <span class="toast" role="status">
          <hc-media-icon name="info" [size]="16"></hc-media-icon>{{ tr('toast.deleted.' + toast.kind) }}
          <button type="button" class="lnk" (click)="onUndo(toast.id)">{{ tr('toast.undo') }}</button>
        </span>
      </div>
    }

    @if (state.messages().length > 0) {
      <div class="msgs" aria-live="polite">
        @for (m of state.messages(); track m.id) {
          <div class="msg" [class.msg-error]="m.level === 'error'" [class.msg-warn]="m.level === 'warn'" [class.msg-info]="m.level === 'info'" [attr.role]="m.level === 'error' ? 'alert' : 'status'">
            <span class="dot" aria-hidden="true"></span>
            <span class="msg-text">@if (m.file) {<b>{{ m.file }}</b>&ngsp;}{{ m.text }}</span>
            <button type="button" class="x" [attr.aria-label]="tr('close')" (click)="state.dismiss(m.id)"><hc-media-icon name="close" [size]="12" [width]="2.4"></hc-media-icon></button>
          </div>
        }
      </div>
    }

    <div class="lower">
      @if (state.editable()) {
        <div class="drop" [class.over]="dropFiles()" (dragover)="onFileDragOver($event)" (dragleave)="onFileDragLeave()" (drop)="onFileDrop($event)">
          <hc-media-icon name="cloud" [size]="40" [width]="1.6"></hc-media-icon>
          <span class="big">{{ tr('drop.before') }} <button type="button" class="lnk" (click)="pick()">{{ tr('drop.choose') }}</button></span>
          <span class="help">{{ tr('drop.several') }}</span>
          <div class="rules">
            <span><b>{{ tr('rules.photo.label') }}</b> {{ tr('rules.photo.text', { max: rules().photoMax, good: rules().good, min: rules().min, photos: rules().photos }) }}</span>
            <span><b>{{ tr('rules.video.label') }}</b> {{ tr('rules.video.text', { max: rules().videoMax, seconds: rules().seconds, minSide: rules().minSide }) }}</span>
            <span><b>{{ tr('rules.compress.label') }}</b> {{ tr('rules.compress.text') }}</span>
          </div>
        </div>
      }

      <hc-media-preview-card [tiles]="state.tiles()" [legacyUrl]="state.legacyUrl()"></hc-media-preview-card>
    </div>

    <div class="notice info note" role="note">
      <hc-media-icon name="info" [size]="16"></hc-media-icon>
      <span>{{ tr('note') }}</span>
    </div>
  }
</section>
